const equipClassOptions = [
  { value: "AIRCP", label: "Air Compressor [AIRCP]" },
  { value: "AIRDL", label: "Air Drill, Crawler [AIRDL]" },
  { value: "AIRTO", label: "Air Tool [AIRTO]" },
  { value: "ASDSP", label: "Asphalt Dike/Shoulder Paver [ASDSP]" },
  { value: "ASPAV", label: "Asphalt Paver [ASPAV]" },
  { value: "ASPWP", label: "Asphalt Windrow/Pickup Machine [ASPWP]" },
  { value: "AUGCL", label: "Auger (Crawler Mounted) [AUGCL]" },
  { value: "AUGHZ", label: "Auger (Horizontal) [AUGHZ]" },
  { value: "AUGTK", label: "Auger (Truck Mounted) [AUGTK]" },
  { value: "BITDT", label: "Bituminous Distributor [BITDT]" },
  { value: "BRMSW", label: "Sweeper [BRMSW]" },
  { value: "COMHG", label: "Compactor (Hand-Guided) [COMHG]" },
  { value: "CONMX", label: "Concrete Mixer [CONMX]" },
  { value: "CONPM", label: "Concrete Pump [CONPM]" },
  { value: "CONSF", label: "Concrete Slipform Paver [CONSF]" },
  { value: "CONVB", label: "Concrete Vibrator [CONVB]" },
  { value: "CRBEX", label: "Curb Extrusion Machine [CRBEX]" },
  { value: "CRBSF", label: "Concrete Barrier Slipform Paver [CRBSF]" },
  { value: "ELGEN", label: "Electric Generator/Light Plant [ELGEN]" },
  { value: "ELTOL", label: "Electric Powered Hand Tool [ELTOL]" },
  { value: "FKLFT", label: "Fork Lift Truck [FKLFT]" },
  { value: "GRADR", label: "Grader [GRADR]" },
  { value: "HAMMR", label: "Hammer (Demolition/Pile) [HAMMR]" },
  { value: "HCECL", label: "Hyd. Crane/Excavator (Crawler) [HCECL]" },
  { value: "HCESP", label: "Hyd. Crane/Excavator (Self-Prop) [HCESP]" },
  {
    value: "HCETD",
    label: "Hyd. Crane/Excavator (Truck Mt. w/Carrier) [HCETD]",
  },
  {
    value: "HCETG",
    label: "Hyd. Crane/Excavator (Truck Mt. w/o Carrier) [HCETG]",
  },
  {
    value: "HYLFT",
    label: "Hyd. Personnel Lifts/Aerial Work Platforms [HYLFT]",
  },
  { value: "LDRCL", label: "Loader (Crawler) [LDRCL]" },
  { value: "LDRRT", label: "Loader (Rubber Tire) [LDRRT]" },
  { value: "LEADS", label: "Lead (Pile Driving) [LEADS]" },
  { value: "NONOP", label: "Non-operated Equipment (Daily Rates) [NONOP]" },
  { value: "PGDIA", label: "Pavement Grinder (Diamond Blade) [PGDIA]" },
  {
    value: "PGT-C",
    label: "Pavement Grinder (Tungsten-Carbide Bits) [PGT-C]",
  },
  { value: "PUMWA", label: "Water Pump [PUMWA]" },
  { value: "ROL_2", label: "Roller (Tandem Steel Wheels) [ROL-2]" },
  { value: "ROLRT", label: "Roller (Rubber Tire, Self-Prop) [ROLRT]" },
  {
    value: "ROTAM",
    label: "Roller-Tapping (Seg., Sheepsft., Self-Prop) [ROTAM]",
  },
  {
    value: "ROTAT",
    label: "Roller-Tamping (Seg., Sheepsft. Towed) [ROTAT]",
  },
  { value: "ROVIB", label: "Roller (Vibratory, Self-Prop) [ROVIB]" },
  { value: "S_CCL", label: "Shovel/Crane (Crawler) [S&CCL]" },
  { value: "S_CTK", label: "Shovel/Crane (Truck Mt.) [S&CTK]" },
  { value: "SANBL", label: "Sand Blasting Equipment [SANBL]" },
  { value: "SAWCH", label: "Saws (Chain, Earth Auger Attach.) [SAWCH]" },
  { value: "SAWCO", label: "Saws (Concrete, Masonry) [SAWCO]" },
  { value: "SCRSP", label: "Scraper (Self-Prop) [SCRSP]" },
  { value: "TRACC", label: "Tractor (Crawler) [TRACC]" },
  { value: "TRACH", label: "Tractor (Heavy) [TRACH]" },
  {
    value: "TRACS",
    label: "Tractor (Rubber Tire, Ind./Farm, Skid Str.) [TRACS]",
  },
  {
    value: "TRAFA",
    label: "Traffic Control/Safety Devices (Hourly) [TRAFA]",
  },
  {
    value: "TRAFC",
    label: "Traffic Control/Safety Devices (Daily) [TRAFC]",
  },
  { value: "TRAIL", label: "Trailer (Equipment - Low Bed) [TRAIL]" },
  { value: "TRAIT", label: "Trailer (Equipment - Tilt Bed) [TRAIT]" },
  { value: "TRENC", label: "Trenching Machine [TRENC]" },
  {
    value: "TRUCK",
    label: "Truck/Truck Trail. (Excl. Dump/Trail) [TRUCK]",
  },
  { value: "TRUOF", label: "Truck (Off-Highway) [TRUOF]" },
  { value: "TRUON", label: "Truck (Dump, On-Highway) [TRUON]" },
  { value: "WELD_", label: "Welding Equipment [WELD]" },
  { value: "STRIP", label: "Striping [STRIP]" },
  { value: "STEM", label: "[STEM]" },
];

export default equipClassOptions;
